import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import {
  HomeMainPC,
  HomeMainTablet,
  HomeMainPopupController,
  // HomeMainAccessChecker,
} from '@container/home';

const stateSelector = state => ({
  ...state.systemReducer,
  ...state.commonReducer,
  ...state.userReducer,
});

const HomeMain = () => {
  const { isTabletMode } = $hooks.useEnv();

  const {
    mainContentInfo,
    channelInfo,
    tokenInfo,
    isPopupDisplayed,
    multiChannelList,
  } = useSelector(stateSelector);
  const [menuInfo, setMenuInfo] = useState(null);
  const isTokenChannel = channelInfo?.cdVal === tokenInfo?.orgChnlCd;
  const isHomeReady = isTokenChannel && !$utils.isNil(multiChannelList);

  const handleSetContentInfo = () => {
    const channelCode = channelInfo?.cdVal;
    const contentInfo = mainContentInfo?.find(
      item => item.channelCode === channelCode,
    );

    const newMenuInfo = {};
    const menuList = contentInfo?.menuInfoList || [];
    menuList.forEach(menuInfo => {
      const { menuCode } = menuInfo;
      const isAlreadyChecked = Object.keys(newMenuInfo).includes(menuCode);
      if (isAlreadyChecked) return;

      const isUse = menuList.some(
        item => item.menuCode === menuCode && item.useYn === 'Y',
      );
      newMenuInfo[menuCode] = isUse;
    });

    setMenuInfo(newMenuInfo);
  };

  useEffect(handleSetContentInfo, [mainContentInfo, channelInfo]);

  return isHomeReady ? (
    <Fragment key={tokenInfo.orgChnlCd}>
      {isTabletMode ? <HomeMainTablet menuInfo={menuInfo} /> : <HomeMainPC />}

      {!isPopupDisplayed && <HomeMainPopupController />}
    </Fragment>
  ) : (
    <></>
  );
};

export default HomeMain;
